import { defineComponent as d, computed as o, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as n, createCommentVNode as f, normalizeStyle as h, createStaticVNode as p } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "ab8549f7-b886-483c-a6cd-35c7f4827ad7" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#ab8549f7-b886-483c-a6cd-35c7f4827ad7)" }, g = { key: 0 }, k = /* @__PURE__ */ p('<path fill="#d80027" d="m0 345 255.7-31L512 345v167H0z"></path><path fill="#ffda44" d="m0 167 258-40.7L512 167v178H0z"></path><path fill="#6da544" d="M0 0h512v167H0z"></path><circle cx="256" cy="256" r="122.4" fill="#0052b4"></circle><g fill="#ffda44"><path d="m256 161.2 22 68h71.7l-58 42 22.3 68.3-58-42.3-58 42.2 22.2-68.1-58-42H234z"></path><path d="m344.1 273-70-22.9 43.2-59.6-18-13L256 237l-43.3-59.7-18 13.1 43.3 59.7-70.1 22.7 6.9 21.2 70-22.8V345h22.3v-73.7l70.1 22.8z"></path></g>', 5), u = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "et",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", v, [
        e.flagName ? (c(), s("title", g, n(e.flagName), 1)) : f("", !0),
        k
      ]),
      t("g", u, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  N as default
};
//# sourceMappingURL=et-a97b45d2.js.map
